import {publishTrackEvent} from "../.."

const TrackInjectedAdLoad = (creativeId: number, uniqueId: string, placementId: number) => {
    publishTrackEvent("osaEvent", {
        eventCat: "osa",
        eventAct: "osa banner load",
        creativeId,
        uniqueId,
        placementId,
    })
}

export default TrackInjectedAdLoad
